import React from 'react';
import WorkerNavbar from '../dashboards/worker/components/WorkerNavbar';
import WorkerSidebar from '../dashboards/worker/components/WorkerSidebar';

function DashboardShell({
  role = 'WORKER',
  sideLinks = [],
  rightPanel,
  children,
}) {
  return (
    <div className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top_left,_rgba(255,122,0,0.12),transparent_20%),radial-gradient(circle_at_bottom_right,_rgba(11,42,74,0.08),transparent_30%),linear-gradient(180deg,#f8fafc_0%,#f1f5f9_100%)] text-slate-900">
      <WorkerNavbar role={role} mobileMenuItems={sideLinks} />

      <main className="mx-auto grid max-w-7xl gap-6 px-4 pt-28 pb-24 sm:px-6 lg:px-8 lg:grid-cols-[260px_minmax(0,1fr)_320px]">
        <aside className="hidden lg:block">
          <WorkerSidebar links={sideLinks} />
        </aside>

        <section className="space-y-6">{children}</section>

        <aside className="hidden lg:block">
          {rightPanel || (
            <div className="rounded-3xl bg-white p-6 shadow-sm">
              <p className="text-sm font-semibold text-navy">Notifications</p>
              <p className="mt-2 text-sm text-slate-600">No new notifications.</p>
            </div>
          )}
        </aside>
      </main>

    </div>
  );
}

export default DashboardShell;

